var React = require('react');

function VideoPlayMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32 0.978516H0V32.9785H32V0.978516ZM10.6813 26.5216L24.5186 18.4935V15.4645L10.6813 7.4364L8 8.94982V25.006L10.6813 26.5216Z","fill":"#FFF7F4"}));
}

VideoPlayMobile.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = VideoPlayMobile;

VideoPlayMobile.default = VideoPlayMobile;
